import { useDroppable } from '@dnd-kit/core';
import { useEffect } from 'react';
import { TRASH_DROPPABLE_ID } from '../../lib/drag-position.js';

/**
 * Ablegezone zum Archivieren, die waehrend des Ziehens am unteren Rand
 * erscheint.
 *
 * Sie bleibt dauerhaft im Baum und wird nur unsichtbar geschaltet. Ein
 * Droppable, das erst mitten im Ziehen einhaengt, ist im selben Bild noch
 * nicht vermessen — es gaebe ein Zeitfenster, in dem die Zone sichtbar ist,
 * aber nicht trifft. Genau dann greift der Nutzer daneben.
 */
export function TrashZone({ visible, active }: { visible: boolean; active: boolean }) {
  const { setNodeRef } = useDroppable({ id: TRASH_DROPPABLE_ID, data: { type: 'trash' } });

  // Ein kurzer Impuls beim Eintreten, wo das Geraet ihn kann: auf dem
  // Smartphone verdeckt der Finger die Zone, das Auge hilft dort nicht.
  useEffect(() => {
    if (active) navigator.vibrate?.(20);
  }, [active]);

  return (
    <div
      ref={setNodeRef}
      data-testid="trash-zone"
      data-active={active ? 'true' : 'false'}
      aria-hidden="true"
      className={`fixed inset-x-0 bottom-[var(--bottom-nav-height)] z-50 flex items-center justify-center transition-opacity duration-150 ${
        visible ? 'opacity-100' : 'pointer-events-none opacity-0'
      }`}
      style={{ height: '5.5rem' }}
    >
      <div
        className={`flex items-center gap-2 rounded-[var(--radius-lg)] border border-dashed px-5 text-sm transition-transform duration-150 ${
          active
            ? 'scale-110 border-danger bg-danger-soft text-danger'
            : 'border-border-strong bg-surface text-muted'
        }`}
        style={{ minHeight: 'var(--touch-target)' }}
      >
        <span aria-hidden="true">🗑</span>
        Zum Archivieren hier ablegen
      </div>
    </div>
  );
}
